import React, { useContext, useEffect, useRef } from 'react';

import { ErrorContext } from 'components/ErrorWrapper/ErrorWrapper';
import { GENERIC_ERROR } from 'constants/appConstants';

import { useQuery } from '@apollo/client';

import { GET_COMMITMENT_METRICS } from 'api/queries';

import { InfoSection, SectionTitle, MetricCell } from "components/CPCommittedCapacity/components/CommonComponents";
import ContentLoader from 'react-content-loader';

import colors from '@arrive/style-foundation/variables/colors-js.scss';
import styles from 'components/CPCommittedCapacity/components/MetricsSection/MetricsSection.scss';

const { tandem } = colors;
const foregroundColor = '#FAFAFA';

const MetricsSectionCompact = ({ loading, tendersOffered, loadAcceptancePercentage }: { loading: boolean; tendersOffered: number; loadAcceptancePercentage: number;}) => {
  if(loading){
    return (
      <>
        <ContentLoader
          key={"receivedMetricsCompactLoading"}
          interval={0.5}
          speed={1.75}
          gradientRatio={0.5}
          width='100%'
          height='66px'
          backgroundColor={tandem}
          foregroundColor={foregroundColor}
        >
          <rect x="0" y="0" width="250" height="16"></rect>
          <rect x="0" y="20" width="125" height="20"></rect>
        </ContentLoader>
        {/* <ContentLoader
          key={"acceptanceMetricsCompactLoading"}
          interval={0.5}
          speed={1.75}
          gradientRatio={0.5}
          width='100%'
          height='66px'
          backgroundColor={tandem}
          foregroundColor={foregroundColor}
        >
          <rect x="0" y="0" width="250" height="16"></rect>
          <rect x="0" y="20" width="125" height="20"></rect>
        </ContentLoader> */}
      </>
    )
  }

  return (
    <>
      <div>
        <div className={styles.metricsCondensedTitle}>Tenders Offered: {tendersOffered} (All-time)</div>
        <div className={styles.metricsCondensedContent}>
          The total count of loads tendered to you.
        </div>
      </div>
      <div>
        <div className={styles.metricsCondensedTitle}>Load Acceptance - {loadAcceptancePercentage}% (All-time)</div>
        <div className={styles.metricsCondensedContent}>
          The percentage of loads accepted out of loads tendered to you.
        </div>
      </div>
    </>
  )
}

export default function MetricsSection({ laneCarrierId, isXS, loadingCommitments }: { laneCarrierId: number; isXS: boolean; loadingCommitments: boolean; }) {
  const { addError, errors, clearErrors } = useContext(ErrorContext);
  const { data = { getTenderMetricsById: {} }, loading, error, refetch } = useQuery(GET_COMMITMENT_METRICS, {
    variables: {
      laneCarrierId: laneCarrierId
    },
    skip: loadingCommitments
  });

  const prevError = useRef(error);

  useEffect(() => {
    const isErrorUnlogged = error && !errors.some((loggedError: Error) => loggedError.message.includes(GENERIC_ERROR));

    if (!loading && error && isErrorUnlogged && addError) {
      addError(new Error(GENERIC_ERROR), refetch, error);
    }
  }, [addError, error, errors, loading, refetch]);

  useEffect(() => {
    if (error !== prevError.current) {
      prevError.current = error;

      if (!error) {
        clearErrors();
      }
    }
  }, [clearErrors, error]);

  return (
    <>
      <SectionTitle title={'Metrics'} />
      <InfoSection className={styles.metricsSection}>
        {isXS ?
          <MetricsSectionCompact loading={loadingCommitments || loading} tendersOffered={data.getTenderMetricsById?.tendersOfferedCount} loadAcceptancePercentage={data.getTenderMetricsById?.loadAcceptancePercentage}/>
          :
          <>
            <MetricCell testIdString={"tenders-offered"} loading={loadingCommitments || loading} title={`Tenders Offered: ${data.getTenderMetricsById?.tendersOfferedCount} (All-time)`} content={'The total count of loads tendered to you.'} />
            <MetricCell testIdString={"load-acceptance"} loading={loadingCommitments || loading} title={`Load Acceptance: ${data.getTenderMetricsById?.loadAcceptancePercentage}% (All-time)`} content={'The percentage of loads accepted out of loads tendered to you.'} />

          </>
        }
      </InfoSection>
    </>
  )
}
